<template>
  <dd-card id="email-create" :class="['flex-stretch', loaded && 'loaded']" wide-content>
    <div v-if="noEmailAccount">
      <dd-back-button class="pl-xl pt-md" :back-handler="goBack"/>
      <NoEmailAccountMessageComponent/>
    </div>
    <div v-else-if="loaded" class="flex-col flex-stretch width-stretch height-stretch">

      <div class="email-info flex-row container-md">

        <div class="flex-row align-items-start p-0 pr-md">
          <dd-rounded-button
              icon="mdi mdi-arrow-left"
              style="margin-top: -5px"
              @click="goBack"
          />
        </div>

        <div class="flex-stretch flex-col gap-md" style="max-width: calc(100% - 50px)">

          <div class="flex-row gap-md width-stretch">
            <div class="flex-row gap-sm align-items-center" style="width: 50%">
              <p style="width: 115px; margin: 0">Versturen aan</p>
              <RecipientInputComponent
                  :customer-id="customerId"
                  v-model="recipient"
                  name="to"
                  data-dusk="emailRecipient"
              />
            </div>
            <div class="flex-row justify-content-end align-items-start" style="width: 50%">
              <dd-button
                  data-dusk="send"
                  tabindex="-1"
                  @click="send"
                  style="max-height: 30px;"
                  icon="mdi mdi-send"
                  :loading="sending"
              >
                Verzenden
              </dd-button>
            </div>
          </div>

          <div class="flex-row gap-md">

            <!--                  left column-->
            <div class="flex-stretch flex-col gap-md" style="width: 50%">
              <div class="flex-row gap-sm align-items-center">
                <p style="width: 115px; margin: 0">Cc</p>
                <RecipientInputComponent
                    :customer-id="customerId"
                    v-model="cc"
                    name="cc"
                />
              </div>
              <div class="flex-row gap-sm align-items-center">
                <p style="width: 115px; margin: 0">Onderwerp</p>
                <dd-input
                    id="subject-input"
                    class="flex-stretch bg-color-white border-radius-xs"
                    v-model="subject"
                    name="email_subject"
                    maxlength="191"
                    data-dusk="emailSubject"
                    style="min-width: 0"
                />
              </div>
              <div class="flex-row gap-sm align-items-center">
                <p style="min-width: 115px; margin: 0">Verzenden vanaf</p>
                <dd-select
                    id="email-account-input"
                    class="flex-stretch bg-color-white border-radius-xs"
                    :show-search="true"
                    v-model="emailSendAccount"
                    placeholder="Kies een email account..."
                    @input="handleAccountChange"
                    name="from"
                    style="width: calc(100% - 125px);"
                >
                  <a-select-option
                      v-for="(account, index) in emailSendAccounts"
                      :key="index"
                      :value="account.id"
                  >
                    {{ `${account.name} (${account.address})` }}
                  </a-select-option>
                </dd-select>
              </div>
              <div class="flex-row gap-sm align-items-center">
                <p style="min-width: 115px; margin: 0">Opslaan als</p>
                <dd-input
                    v-model="nameInSystem"
                    class="flex-stretch bg-color-white border-radius-xs"
                    name="name"
                    maxlength="190"
                    style="min-width: 0"
                />
              </div>
            </div>

            <!--                  right column-->
            <div class="flex-stretch flex-col gap-md" style="width: 50%; min-width: 48%">
              <div class="flex-row gap-sm align-items-center">
                <p style="min-width: 115px; margin: 0">Bcc</p>
                <RecipientInputComponent
                    :customer-id="customerId"
                    v-model="bcc"
                    name="bcc"
                />
              </div>
              <TemplateSelect
                  name="template_id"
                  @input="acceptTemplate"
              />
              <div class="flex-row gap-sm align-items-center">
                <p style="min-width: 115px; margin: 0">HTML Template</p>
                <dd-input
                    value="Standaard opmaak"
                    :disabled="true"
                    class="flex-stretch border-radius-xs"
                    style="min-width: 0"
                />
              </div>
              <div class="flex-row gap-sm align-items-center">
                <p style="min-width: 115px; margin: 0">Opslaan in</p>
                <dd-select
                    class="flex-stretch bg-color-white border-radius-xs"
                    name="attachableCategory_id"
                    v-model="attachable_category"
                    rules="required"
                    data-dusk="attachable_category_select"
                >
                  <a-select-option
                      v-for="(category, index) in attachable_categories"
                      :key="index"
                      :value="category.id"
                  >
                    {{ category.name }}
                  </a-select-option>
                </dd-select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AttachmentsComponent
          v-model="attachments"
          editable
          :customer-id="customerId"
      />

      <ContentComposerComponent
          v-model="content"
          :signature="signature"
          :footer="footer"
          :templateContents="templateContents"
      />
    </div>

    <create-task-modal
        id="create-task-dialog"
        :visible="showCreateTaskDialog"
        @cancel="hideCreateTaskDialog"
        description="Je hebt een email verzonden. Wil je hiervoor een taak aanmaken?"
        :customerId="customerId"
        :category="category"
        :instanceClass="instanceClass"
        :instanceId="instanceId"
        :preventRedirect="!isCustomerPage"
    />
    <navigate-to-customer-modal
        id="create-success-dialog"
        :visible="showNavigateToCustomerDialog"
        @cancel="hideNavigateToCustomerDialog"
        :customerId="customerId"
    />

  </dd-card>
</template>

<script>
import store from "~/new_design_components/layouts/form_page/store";
import attachableCategoryApi from "~/api/attachable_category";
import emailUtils from "~/util/email";
import emailApi from "~/api/email";
import emailFooterApi from "~/api/email_footer";
import CreateTaskModal from "~/pages/components/modal/dialog/CreateTaskModal";
import NavigateToCustomerModal from "~/pages/components/modal/dialog/NavigateToCustomerModal";
import TemplateSelect from "./TemplateSelect.vue";
import AttachmentsComponent from "./AttachmentsComponent.vue";
import RecipientInputComponent from "./recipient/RecipientInputComponent.vue";
import SendStateEnum from "../enums/SendStateEnum";
import CategoryByClassEnum from "~/enums/CategoryByClassEnum";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import ContentComposerComponent from "./ContentComposerComponent.vue";
import NoEmailAccountMessageComponent from "~/pages/email/components/NoEmailAccountMessageComponent.vue";

export default {
  name: "EmailCreateComponent.vue",
  components: {
    CreateTaskModal,
    NavigateToCustomerModal,
    RecipientInputComponent,
    TemplateSelect,
    AttachmentsComponent,
    ContentComposerComponent,
    NoEmailAccountMessageComponent
  },
  data() {
    return {
      loaded: false,
      noEmailAccount: false,
      sending: false,
      showCreateTaskDialog: false,
      showNavigateToCustomerDialog: false,
      signature: "",
      footer: {},
      templateContents: "",
      content: "",
      recipient: [],
      uploadedFiles: [],
      selectedDocuments: [],
      attachable_categories: [],
      attachable_category: undefined,
      emailSendAccount: undefined,
      selectedTemplateId: 0,
      cc: [],
      bcc: [],
      subject: "",
      nameInSystem: "",
    };
  },
  beforeCreate() {
    const STORE_KEY = "$_form_page";
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) this.$store.registerModule(STORE_KEY, store);
  },
  created() {
    this.getValidationRulesForRouteName("web_api.v1.email.email.create.post");
  },
  async mounted() {
    setTimeout(async () => {

      await this.$store.dispatch("email/loadAccounts");

      this.emailSendAccount = this.emailSendAccounts[0]?.id;

      if (!this.emailSendAccount){
        this.noEmailAccount = true;
        return;
      }

      this.updateSignature();
      await this.updateFooter();

      if (this.category && !this.instanceId) {

        const { data } = await attachableCategoryApi.getByCustomerAndCategory(this.customerId, this.category);
        this.attachable_categories = data;

      } else {

        const { data } = await attachableCategoryApi.getByClass(this.instanceClass, this.instanceId);
        this.attachable_categories = data;

      }

      this.loaded = true;

    }, 200);
  },
  methods: {
    ...mapActions(`$_form_page`, {
      getValidationRulesForRouteName: "getValidationRulesForRouteName",
    }),
    ...mapActions("email", [
      "goBack",
      "setSendState"
    ]),
    ...mapMutations("$_form_page", [
      "SET_AXIOS_ERROR"
    ]),
    handleAccountChange() {
      this.updateSignature();
      this.updateFooter();
    },
    async acceptTemplate({
      id,
      parsedTemplate
    }) {
      this.templateContents = "";
      this.selectedTemplateId = id;
      this.nameInSystem = "";
      this.subject = "";
      this.cc = [];
      this.bcc = [];
      this.recipient = [];

      if (this.selectedTemplateId !== 0) {
        this.templateContents = parsedTemplate.content;
        if (parsedTemplate.nameInSystem) this.nameInSystem = parsedTemplate.nameInSystem;
        if (parsedTemplate.title) this.subject = parsedTemplate.title;
        if (parsedTemplate.email_cc) this.cc.push(...parsedTemplate.email_cc.split(", "));
        if (parsedTemplate.email_bcc) this.bcc.push(...parsedTemplate.email_bcc.split(", "));
        if (parsedTemplate.primaryMail) this.recipient.push(...parsedTemplate.primaryMail.split(", "));
      }
    },
    updateSignature() {
      this.signature = this.emailSendAccounts.find(account => account.id === this.emailSendAccount).signature || "";
    },
    async updateFooter() {
      this.footer = await emailFooterApi.getByEmailaccountAndUser(this.emailSendAccount, this.$store.state.user.id);
    },
    async send() {
      if (this.sending === true) {
        console.log("Already sending");
        return;
      }

      this.sending = true;

      // blur inputs
      const inputs = document.querySelectorAll("input:focus");
      for (let input in inputs) {
        if (input.blur) input.blur();
      }

      setTimeout(async () => { //wait for blur
        const data = {
          email_account_id: this.emailSendAccount,
          template_id: this.selectedTemplateId > 0 ? this.selectedTemplateId : null,
          email_subject: this.subject,
          name: this.nameInSystem.trim().length > 0 ? this.nameInSystem : this.subject,
          to: this.recipient.map(address => emailUtils.getCleanAddress(address)),
          to_cc: this.cc || [],
          to_bcc: this.bcc || [],
          uploadedFiles: this.uploadedFiles.map(file => file.uuid),
          attachables: this.selectedDocuments.map(document => document.id),
          process_original: true,
          content: this.content.replace(/id="([^"]*)"/g, ""),
          instance_class: this.instanceClass,
          instance_id: this.instanceId || this.customerId,
          customer_id: this.customerId,
          attachableCategory_id: this.attachable_category,
          attachableIsTemplate: this.attachable_categories.find(category => category.id === this.attachable_category)?.template
        };

        try {
          const response = await emailApi.create(data);
          if (response.data.success) {
            this.$notification["success"]({
              message: "De e-mail is succesvol verzonden.",
            });
            this.showCreateTaskDialog = true;
          } else {
            this.saveError(response);
          }
        } catch (error) {
          this.$notification["error"]({
            message: "Er ging iets verkeerd tijdens het versturen. Probeer het opnieuw.",
          });
          this.saveError(error);
          this.sending = false;
        }
      }, 200);
    },
    saveError(error) {
      this.$store.commit("$_form_page/SET_AXIOS_ERROR", error, { root: true });
    },
    hideCreateTaskDialog(preventGoBack) {
      this.showCreateTaskDialog = false;
      if (preventGoBack) return;
      if (this.isCustomerPage) {
        this.navigator.back();
      } else {
        this.showNavigateToCustomerDialog = true;
      }
    },
    hideNavigateToCustomerDialog() {
      this.showNavigateToCustomerDialog = false;
      this.goBack();
    }
  },
  computed: {
    ...mapGetters("email", [
      "accounts",
      "templateById",
      "isCustomerPage"
    ]),
    ...mapState("email", [
      "createEmailCustomerId"
    ]),
    attachments: {
      get() {
        return {
          uploaded: this.uploadedFiles,
          selected: this.selectedDocuments
        };
      },
      set(attachments) {
        this.uploadedFiles = attachments.uploaded;
        this.selectedDocuments = attachments.selected;
      }
    },
    customerId() {
      return this.$route.params?.customerId || this.createEmailCustomerId;
    },
    category() {
      return this.$route.params?.category || CategoryByClassEnum[this.instanceClass];
    },
    instanceClass() {
      return this.$route.params?.instanceClass || "customer";
    },
    instanceId() {
      return this.$route.params?.instanceId;
    },
    emailSendAccounts() {
      return this.accounts.filter(account => !account.isMailbox);
    },
    isReplyState() {
      return this.sendState === SendStateEnum.REPLY;
    }
  }
};

</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

.email-info {
  min-height: 115px;
  height: auto;
}

iframe {
  border: none;
}

a {
  text-decoration: underline;
  text-decoration-color: $color-black;
}

.send-button-container {
  padding-top: 2.5px;
  padding-bottom: 2.5px;
}
</style>

<style lang="scss">
@import "~@/_default.scss";

.recipient-tags {
  display: none;
}

.ant-select-selection--multiple {
  min-height: $spacing-xl;
}

.email-info {
  max-width: 100%;
}
</style>
